import { terUtils_make_smartbom_manifest_terkk_v1_0, terUtils_make_smartbom_manifest_terkk_v1_2 } from "./ter-smartbom-utils";


// COMPATIBILITY


//
export const _compatibility_fix_lib_materijal_lim_lib_obj = (lib_obj) => {
  let kategorijamaterijala = "LIM"; // FIX default je LIm za sve koji su dodati ranije u bazu
  if ("kategorijamaterijala" in lib_obj) {
    kategorijamaterijala = lib_obj.kategorijamaterijala;
  }
  const fixed = {
    ...lib_obj, // koristimo samo ovaj deo entity-ja iz baze
    kategorijamaterijala
  };
  if (lib_obj.kategorijamaterijala !== "LIM") {
    delete lib_obj.debljina_materijala;
    delete lib_obj.k_faktor;
  }
  return fixed;
};


//
export const _compatibility_fix_smartbom = (smartbom, resbox_version) => {
  // DIRTY MUTATE
  if (typeof smartbom.smartbom_version === 'string') {
    // no changes
  } else {
    smartbom.smartbom_version = "1"; // default version "1".
    if (smartbom.self) {
      // no changes
    } else {
      smartbom.self = {};
    }
    if (resbox_version === "2") {
      // iz baze virbom version 2 - virbom_resbox
      smartbom.self.manifest = terUtils_make_smartbom_manifest_terkk_v1_2();
    } else {
      // iz baze virbom version 1 - virbom_resbox
      smartbom.self.manifest = terUtils_make_smartbom_manifest_terkk_v1_0();
    }
  }
  return smartbom;
};


//
export const _compatibility_fix_sastavnica_internal = (sastavnica_internal, virbom_rev_id) => {
  // DIRTY MUTATE
  sastavnica_internal.forEach((row_obj) => {
    row_obj.authorBomRevId = virbom_rev_id; // dodajemo i podatak id revizije u sastavnicu kako bi mogli da koristimo vise sastavnica pri eksportu.
    // if (p.rc === "RCPRBAM") {
    // if (row_obj._CNC_tip === "RCPRBAM") {
    if (row_obj._CNC_tip === "AMADA") {
      // ODLUKA DL 2022-12-06: Tamo gde je radni centar amada da bude isti cncprogram kao i cnccrtez.
      // DL 2024-04-27: Do sada je kod LIM CUSTOM polje cnccrtez bilo korisceno za CNC program a od sada treba da imamo oba polja i za S4 i za AMADA.
      // j.CNC_program1 = p.cnccrtez;
      if (row_obj.virtelclass === 'terkk$limcustom' && (row_obj.CNC_program1 === null || typeof row_obj.CNC_program1 !== 'string')) {
        row_obj.CNC_program1 = row_obj.CNC_crtez; // FIX kod starijih limcustom nije bilo popunjeno polje cnprogram1 nego samo cnccrtez
      }
      if (row_obj.CNC_program1 === null || typeof row_obj.CNC_program1 !== 'string') {
        // za sada to isto radime i za sve ostale elemente koji su AMADA tip CNC programa
        row_obj.CNC_program1 = row_obj.CNC_crtez;
      }
    }
    if (typeof row_obj.Par_jezik === 'string' && row_obj.Par_jezik === '') {
    } else {
      if (row_obj.virtelclass === "terkk$klimakomora") {
        row_obj.Par_jezik = "terkk$klimakomora/klimakomora";
      }
      if (row_obj.virtelclass === "terkk$modul") {
        row_obj.Par_jezik = "terkk$modul/modul";
      }
      if (row_obj.Grupa === "PROFIL") {
        row_obj.Par_jezik = "terkk$grupa_profil/grupa_profil";
      }
      if (row_obj.Grupa === "ISPUNA") {
        row_obj.Par_jezik = "terkk$grupa_ispuna/grupa_ispuna";
      }
    }
  });
  return sastavnica_internal;
};

